import React, { useEffect, useState } from 'react'
import { Link, navigate } from 'gatsby'
import './style.less'
import {
    FileTextOutlined,
    FolderOutlined,
    ArrowLeftOutlined,
    PlusOutlined,
    LockOutlined,
    // HomeOutlined,
    FileSyncOutlined,
    BookOutlined,
    ExclamationCircleTwoTone,
    // LoadingOutlined,
    SyncOutlined,
} from '@ant-design/icons'
import { Layout, Menu } from 'antd'
import makeStyles from '@mui/styles/makeStyles';
import Divider from '@mui/material/Divider'
import Typography from '@mui/material/Typography'
import CreateTaxYear from './CreateTaxYear'
import { IPeriodCache, IPeriodConfig } from '../../lib/interfaces'
import { mapEXPeriodData } from '../../lib/dateFunctions'
import { httpGet } from '../../services/http'
import { ITaxYear, ITaxYearDataRes } from './types'

const useStyles = makeStyles((theme) => ({
    dividerFullWidth: {
        margin: `5px 0 0 ${theme.spacing(2)}`,
        color: '#D7E6F5',
    },
    dividerCol: {
        backgroundColor: '#D7E6F5',
    },
}))

const { Sider } = Layout
const { SubMenu } = Menu

export default function LLUserComplianceReports({
    getTaxYearData,
    loadOverviewData,
    renderTaxYearContent,
    selectedKey,
    setSelectedKey,
    taxYears,
    isLoading,
    userData,
    isBackgroundLoading,
}: {
    getTaxYearData: (taxYear: ITaxYear, forceFetch?: boolean) => Promise<ITaxYearDataRes>
    loadOverviewData: (postSwitchToTab?: string) => Promise<ITaxYear[]>
    renderTaxYearContent
    selectedKey
    setSelectedKey
    taxYears
    isLoading
    userData
    isBackgroundLoading
}) {
    const [userName, setUserName] = useState<string>('')
    const [llPeriods, setLlPeriods] = useState<IPeriodCache[]>([])
    const updatellPeriodsData = (data) => {
        setLlPeriods(mapEXPeriodData(data?.dateRanges))
    }
    const classes = useStyles()

    useEffect(() => {
        if (!(userData && userData.name)) return
        setUserName(userData.name)
    }, [userData])

    useEffect(() => {
        httpGet<IPeriodConfig>('/get-ll-periods').then((periodsData) => {
            updatellPeriodsData(periodsData.data)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function renderContent() {
        const view = selectedKey.split(';;;')[0]
        switch (view) {
            case 'create':
                return (
                    <CreateTaxYear
                        loadOverviewData={loadOverviewData}
                        llPeriods={llPeriods}
                        userData={userData}
                    />
                )
            case 'taxYear':
            case 'taxYearReport':
                return renderTaxYearContent()
        }
    }

    return (
        <>
            <div style={{ height: '56px' }}>
                <div className="nav-header-reporting">
                    <div className="header-content-reporting">
                        <Link to="/">
                            <div style={{ marginRight: 20 }} className="logoImg" />
                        </Link>
                        <h3 className="header-title-reporting">{userName}</h3>
                        {isBackgroundLoading && (
                            <div
                                style={{
                                    display: 'flex',
                                    flexDirection: 'row',
                                    justifyContent: 'center',
                                    textAlign: 'right',
                                    marginLeft: 20,
                                }}
                            >
                                <h4 className="inverse-h" style={{ marginRight: '10px' }}>
                                    Updating...
                                </h4>
                                <SyncOutlined
                                    style={{ fontSize: 24, color: 'white', alignSelf: 'center' }}
                                    spin
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Layout>
                <Sider width={300} className="side-bar-reporting">
                    <Menu theme="dark" mode="inline" selectedKeys={[selectedKey]}>
                        <Menu.Item
                            key="back"
                            icon={<ArrowLeftOutlined />}
                            onClick={() => {
                                navigate('/app')
                            }}
                        >
                            Back to app
                        </Menu.Item>
                        {/* <Menu.Item
                            key="overview"
                            icon={<HomeOutlined />}
                            onClick={() => {
                                setSelectedKey('overview')
                            }}
                        >
                            Home
                        </Menu.Item> */}
                        <Menu.Item
                            key="create"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                setSelectedKey('create')
                            }}
                        >
                            Create Tax Year
                        </Menu.Item>
                        {/* <Divider style={{ color: '#D7E6F5' }} plain orientation="center">
                            My Tax Years
                        </Divider> */}
                        <Divider component="li" light classes={{light: classes.dividerCol}} />
                        <li>
                            <Typography
                                className={classes.dividerFullWidth}
                                color="textSecondary"
                                display="block"
                                variant="caption"
                            >
                                My Tax Years
                            </Typography>
                        </li>
                        {taxYears
                            .sort((a, b) => Number(a.tax_year) - Number(b.tax_year))
                            .map((ty) => {
                                return (
                                    <>
                                        <SubMenu
                                            key={`taxYearSubMenu;;;${ty.id}`}
                                            icon={
                                                ty.is_locked ? (
                                                    <LockOutlined />
                                                ) : (
                                                    <FileSyncOutlined />
                                                )
                                            }
                                            title={
                                                <span>
                                                    {`${ty.tax_year}`}
                                                    {!ty.is_updated && (
                                                        <ExclamationCircleTwoTone twoToneColor="#f5222d" />
                                                    )}
                                                </span>
                                            }
                                        >
                                            <Menu.Item
                                                key={`taxYear;;;${ty.id}`}
                                                icon={<BookOutlined />}
                                                onClick={() => {
                                                    setSelectedKey(`taxYear;;;${ty.id}`)
                                                }}
                                            >
                                                <span>
                                                    Overview{' '}
                                                    {!ty.is_updated && (
                                                        <ExclamationCircleTwoTone twoToneColor="#f5222d" />
                                                    )}
                                                </span>
                                            </Menu.Item>
                                            <SubMenu
                                                key={`taxYearReportMenu;;;${ty.id}`}
                                                icon={<FolderOutlined />}
                                                title="Compliance Reports"
                                            >
                                                {ty.report_ids
                                                    .sort((a, b) => Number(a.idx) - Number(b.idx))
                                                    .map((reportIdObj) => {
                                                        return (
                                                            <Menu.Item
                                                                key={`taxYearReport;;;${ty.id}:::${reportIdObj.id}`}
                                                                icon={
                                                                    reportIdObj.is_locked ? (
                                                                        <LockOutlined />
                                                                    ) : (
                                                                        <FileTextOutlined />
                                                                    )
                                                                }
                                                                onClick={() => {
                                                                    setSelectedKey(
                                                                        `taxYearReport;;;${ty.id}:::${reportIdObj.id}`
                                                                    )
                                                                }}
                                                            >
                                                                Report - {reportIdObj.idx}
                                                            </Menu.Item>
                                                        )
                                                    })}
                                            </SubMenu>
                                        </SubMenu>
                                    </>
                                )
                            })}
                    </Menu>
                </Sider>
                <Layout>{renderContent()}</Layout>
            </Layout>
        </>
    )
}
